import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const pluginName = "netselos";

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: pluginName,
      storage,
      whitelist: ["auth", "register"],
    },
    reducers
  );
  return persistedReducer;
};
